import { render, staticRenderFns } from "./CustomDataChips.vue?vue&type=template&id=f6fe2800"
import script from "./CustomDataChips.vue?vue&type=script&lang=js"
export * from "./CustomDataChips.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports